import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import Menu from '@mui/material/Menu';

import { slugify } from 'helpers/slugify';

import MenuSectionBarNavItem from 'components/MenuSectionBarNavItem';
import MenuSectionBarMoreButton from 'components/MenuSectionBarMoreButton';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    paddingTop: '1.25rem',
    paddingBottom: '.25rem',
    paddingLeft: '.5rem',
    boxShadow:
      'rgba(0, 0, 0, 0.08) 0px 3px 10px 0px, rgba(0, 0, 0, 0.01) 0px 1px 0px 0px, rgba(0, 0, 0, 0.01) 0px 0px 5px 0px',
    borderRadius: '8px',
    backgroundColor: getPageBackgroundColor(theme)
  }
}));

function MenuSectionBarDropDown({
  menuSections,
  activeMenuSectionName,
  offset,
  handleSetActive
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openDropDown = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeDropDown = () => {
    setAnchorEl(null);
  };

  /**
   * Handles the clicking of a section item. First closeDropDown is called
   * which is responsible for closing the dropdown. Next handleSetActive
   * is called. A callback argument 'to' is passed to the handleSetActive
   * method to set the current handle item.
   *
   * @param {} to callback string section name argument passed in from MenuSectionBarNavItem
   */
  const handleSectionItemClick = to => {
    closeDropDown();
    handleSetActive(to);
  };

  const isDropDownSectionSelected = () => {
    const isDropselectedSelected = menuSections.find(
      sectionItem => slugify(sectionItem.name) === activeMenuSectionName
    );

    return Boolean(isDropselectedSelected);
  };

  const isMoreButtonHighlighted = isDropDownSectionSelected();

  return (
    <React.Fragment>
      <MenuSectionBarMoreButton
        isHighlighted={isMoreButtonHighlighted}
        onClick={openDropDown}
        isExpanded={Boolean(anchorEl)}
      />
      <StyledMenu
        id="menu-section-more-dropdown"
        data-testid="menu-section-more-dropdown"
        anchorEl={anchorEl}
        anchorReference="anchorEl"
        keepMounted
        open={Boolean(anchorEl)}
        onClose={closeDropDown}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {menuSections.map(section => (
          <MenuSectionBarNavItem
            style={{
              paddingBottom: '8px',
              color: 'green'
            }}
            key={`${section.id}`}
            onClick={closeDropDown}
            menuSection={section}
            handleSetActive={handleSectionItemClick}
            activeMenuSectionName={activeMenuSectionName}
            justifyContent={'left'}
            offset={offset}
            hasBottomPadding={false}
            hasTopPadding={false}
            isInMoreSection={true}
          />
        ))}
      </StyledMenu>
    </React.Fragment>
  );
}

MenuSectionBarDropDown.propTypes = {
  handleSetActive: PropTypes.func,
  menuSections: PropTypes.array,
  activeMenuSectionName: PropTypes.string,
  offset: PropTypes.number
};

export default MenuSectionBarDropDown;
